/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import {
    isAlphabet,
    isBlank,
    isChinese,
    isHyphenBlank,
    isNumber,
    isString,
    isSymbol,
    isTime,
} from './asserts';
import { ErrorType } from './errorType';
import { TokenType } from './grammar.type';
import * as GrammarUtils from './grammar.util';

/**
 * LUN IOPS TOP => [
 *      {type:string,value:LUN},
 *      {type:string,value:IOPS},
 *      {type:string,value:TOP},
 * ]
 * LUN Capacity>5=>[
 *      {type:string,value:LUN},
 *      {type:string,value:Capacity},
 *      {type:symbol,value:>}
 *      {type:number,value:5},
 * ]
 * @param input
 */
export function tokenizer(input, updateError = true): any[] {
    let current = 0;
    const tokens = [];
    while (current < input.length) {
        let currentChar = input[current];
        if (isBlank(currentChar)) {
            while (isBlank(currentChar)) {
                currentChar = input[++current];
            }
            continue;
        }
        if (isSymbol(currentChar)) {
            let value = '';
            while (isSymbol(currentChar)) {
                value += currentChar;
                currentChar = input[++current];
            }
            tokens.push({ type: TokenType.Symbol, value });
            continue;
        }
        if (isChinese(currentChar)) {
            let value = '';
            while (isChinese(currentChar)) {
                value += currentChar;
                currentChar = input[++current];
            }
            if (isHyphenBlank(currentChar)) {
                tokens.push({ type: TokenType.Chinese, value });
                continue;
            }
            while (!isHyphenBlank(currentChar)) {
                value += currentChar;
                currentChar = input[++current];
            }
            tokens.push({ type: TokenType.String, value });
            continue;
        }
        if (isAlphabet(currentChar)) {
            let value = '';
            while (isAlphabet(currentChar)) {
                value += currentChar;
                currentChar = input[++current];
            }
            if (isHyphenBlank(currentChar)) {
                tokens.push({ type: TokenType.Alphabet, value });
                continue;
            }
            while (!isHyphenBlank(currentChar)) {
                value += currentChar;
                currentChar = input[++current];
            }
            tokens.push({ type: TokenType.String, value });
            continue;
        }
        if (isNumber(currentChar)) {
            let value = '';
            while (isNumber(currentChar)) {
                value += currentChar;
                currentChar = input[++current];
            }
            if (isTime(currentChar)) {
                while (isTime(currentChar)) {
                    value += currentChar;
                    currentChar = input[++current];
                }
                if (isHyphenBlank(currentChar)) {
                    tokens.push({ type: TokenType.Time, value });
                    continue;
                }
                while (!isHyphenBlank(currentChar)) {
                    value += currentChar;
                    currentChar = input[++current];
                }
                tokens.push({ type: TokenType.String, value });
                continue;
            }
            if (isHyphenBlank(currentChar)) {
                tokens.push({ type: TokenType.Number, value });
                continue;
            }
            while (!isHyphenBlank(currentChar)) {
                value += currentChar;
                currentChar = input[++current];
            }
            tokens.push({ type: TokenType.String, value });
            continue;
        }
        if (isString(currentChar)) {
            let value = '';
            while (isString(currentChar)) {
                value += currentChar;
                currentChar = input[++current];
            }
            tokens.push({ type: TokenType.String, value });
            continue;
        }
        if (updateError) {
            GrammarUtils.error({ type: ErrorType.INVALID_TOKEN, value: currentChar });
        } else {
            throw new Error(currentChar);
        }
    }
    return tokens;
}


